import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-processing-payment-dialog',
    templateUrl: 'processing-payment-dialog.html',
    styleUrls: ['processing-payment-dialog.scss']
})
export class ProcessingPaymentDialogComponent {
    isLoading = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            isAccountVerified: boolean,
            isPaymentAuthorise: boolean,
            isAuthorisationRequired: boolean,
            isLoading: boolean,
            is400: boolean,
            is500: boolean,
            errorMessage: string,
            successMessage: string,
            returnUrl?: string,
            isHelped: boolean,
            subscriptionName?: string
        },
        @Inject(DOCUMENT) private document: any,
        private dialogRef: MatDialogRef<ProcessingPaymentDialogComponent>,
        private router: Router
    ) { }

    redirect3DSecure(): void {
        setTimeout(() => {
            this.dialogRef.close();
            this.document.location.href = this.data.returnUrl;
        }, 5000);
    }

    redirect() {
        environment.STAGE === 'prod' ? this.goToWebsite() : this.connect();
    }
    private goToWebsite() {
        window.location.href = 'https://www.co-assist.fr/merci-commande';
    }

    private connect(): void {
        setTimeout(() => {
            this.dialogRef.close();
            this.router.navigate(['/login']);
        }, 3000);
    }
}
